var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsiteLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2754 38.6335V39.3168C31.2754 39.498 31.2034 39.6717 31.0753 39.7999C30.9472 39.928 30.7734 40 30.5922 40H18.294C18.1128 40 17.9391 39.928 17.8109 39.7999C17.6828 39.6717 17.6108 39.498 17.6108 39.3168V38.6335L19.6605 37.2671V33.1677H29.2257V37.2671L31.2754 38.6335Z",
    fill: "#A4B0C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8407 30.9334H41.727V30.047V13.4361C41.727 12.4309 41.3221 11.4694 40.6053 10.7623C39.8889 10.0557 38.9198 9.6609 37.9119 9.6609H10.0881C9.08018 9.6609 8.1111 10.0557 7.39471 10.7623C6.67791 11.4694 6.27296 12.4309 6.27296 13.4361V30.047V30.9334H7.15931H40.8407Z",
    fill: "white",
    stroke: "#4C5B66",
    strokeWidth: 1.7727
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0965 34.4788V37.1378L31.0908 38.0242V38.9105C31.0908 39.1456 31.0208 39.3711 30.8961 39.5373C30.7714 39.7035 30.6024 39.7969 30.4261 39.7969H18.4603C18.284 39.7969 18.1149 39.7035 17.9902 39.5373C17.8656 39.3711 17.7955 39.1456 17.7955 38.9105V38.0242L19.7898 37.1378V30.9334",
    stroke: "#474C54",
    strokeWidth: 1.7727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2387 20.2971C22.3996 20.2971 25.7727 16.924 25.7727 12.7631C25.7727 8.60223 22.3996 5.22915 18.2387 5.22915C14.0778 5.22915 10.7047 8.60223 10.7047 12.7631C10.7047 16.924 14.0778 20.2971 18.2387 20.2971Z",
    fill: "white",
    stroke: "#474C54",
    strokeWidth: 1.7727
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2245 15.5838C11.9124 17.3459 13.2332 18.7878 14.9283 19.6273C16.6235 20.4668 18.571 20.6433 20.3894 20.1223C22.2079 19.6014 23.7665 18.4204 24.7599 16.8107C25.7534 15.2009 26.1103 13.2784 25.7608 11.4193C25.4112 9.56026 24.3803 7.89863 22.87 6.75972C21.3596 5.62081 19.4786 5.08663 17.5951 5.26178C15.7116 5.43693 13.9612 6.30878 12.6868 7.70665C11.4123 9.10451 10.7055 10.9277 10.7047 12.8194H24.7599",
    stroke: "#474C54",
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2933 20.4062V5.22914C18.2933 5.22914 26.9659 11.7336 18.2933 20.4062Z",
    stroke: "#474C54",
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2933 9.66258C18.2933 9.66258 9.62072 16.167 18.2933 24.8397",
    stroke: "#474C54",
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3181 20.2971H38.1816",
    stroke: "#474C54",
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3181 18.5244H38.1816",
    stroke: "#474C54",
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3181 22.0698H38.1816",
    stroke: "#474C54",
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20476 29.6038H41.727V31.8197C41.727 32.2899 41.4022 32.7408 40.8241 33.0732C40.2459 33.4057 39.4617 33.5924 38.6441 33.5924H9.35592C8.53827 33.5924 7.7541 33.4057 7.17594 33.0732C6.59777 32.7408 6.27296 32.2899 6.27296 31.8197V29.1607",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20476 29.6038H41.727V31.8197C41.727 32.2899 41.4022 32.7408 40.8241 33.0732C40.2459 33.4057 39.4617 33.5924 38.6441 33.5924H9.35592C8.53827 33.5924 7.7541 33.4057 7.17594 33.0732C6.59777 32.7408 6.27296 32.2899 6.27296 31.8197V29.1607",
    stroke: "#474C54",
    strokeWidth: 1.7727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15931 12.32V28.2743H40.8407L7.15931 12.32Z",
    fill: "#E0E0E0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2387 20.2971C22.3996 20.2971 25.7727 16.9241 25.7727 12.7631C25.7727 8.60223 22.3996 5.22915 18.2387 5.22915C14.0778 5.22915 10.7047 8.60223 10.7047 12.7631C10.7047 16.9241 14.0778 20.2971 18.2387 20.2971Z",
    fill: "#9CCFFF",
    stroke: "#474C54",
    strokeWidth: 1.7727
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2245 15.5838C11.9124 17.3459 13.2332 18.7879 14.9283 19.6273C16.6235 20.4668 18.571 20.6433 20.3894 20.1223C22.2079 19.6014 23.7665 18.4204 24.7599 16.8107C25.7534 15.201 26.1103 13.2784 25.7608 11.4193C25.4112 9.56027 24.3803 7.89863 22.87 6.75972C21.3596 5.62081 19.4786 5.08664 17.5951 5.26178C15.7116 5.43693 13.9612 6.30878 12.6868 7.70665C11.4123 9.10452 10.7055 10.9277 10.7047 12.8194H24.7599",
    stroke: "#474C54",
    strokeOpacity: 0.4,
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2932 20.4079V5.23083C18.2932 5.23083 26.9659 11.7353 18.2932 20.4079Z",
    stroke: "#474C54",
    strokeOpacity: 0.4,
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2933 5.23083C18.2933 5.23083 9.6207 11.7353 18.2933 20.4079",
    stroke: "#474C54",
    strokeOpacity: 0.4,
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2045 24.7289H31.5709",
    stroke: "#474C54",
    strokeWidth: 1.7727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7047 24.7289H12.0712",
    stroke: "#474C54",
    strokeWidth: 1.7727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25H37.5417",
    stroke: "#474C54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteLink);
export default __webpack_public_path__ + "static/media/website_link.c61aa2bbbcc4aa71938485e674520430.svg";
export { ForwardRef as ReactComponent };